import { cn } from "@/lib/utils";

export type Tone = "success" | "warning" | "danger" | "info" | "pending" | "neutral";

const DOT_TONE: Record<Tone, string> = {
  success: "bg-success",
  warning: "bg-warning",
  danger: "bg-danger",
  info: "bg-info",
  pending: "bg-pending",
  neutral: "bg-disabled",
};

export function StatusDot({
  tone = "neutral",
  pulse = false,
  className,
}: {
  tone?: Tone;
  pulse?: boolean;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn("inline-block size-2 shrink-0 rounded-full", DOT_TONE[tone], pulse && "animate-pulse", className)}
    />
  );
}

export function EnvBadge({
  env,
  className,
}: {
  env: "Production" | "Sandbox" | "Testnet" | string;
  className?: string;
}) {
  const tone: Tone = env === "Production" ? "danger" : env === "Sandbox" ? "warning" : "info";
  return (
    <span
      className={cn(
        "rounded-full px-2 py-0.5 text-xs font-extrabold uppercase tracking-[0.05em]",
        tone === "danger" && "bg-danger-soft text-danger",
        tone === "warning" && "bg-warning-soft text-warning",
        tone !== "danger" && tone !== "warning" && "bg-info-soft text-info",
        className
      )}
    >
      {env}
    </span>
  );
}

export function StaleIndicator({
  stale,
  label,
  title,
  className,
}: {
  stale: boolean;
  label?: string;
  title?: string;
  className?: string;
}) {
  return (
    <span className={cn("inline-flex items-center gap-1.5 text-xs text-muted", className)} title={title}>
      <StatusDot tone={stale ? "warning" : "success"} />
      {label}
    </span>
  );
}